import { render } from "./AddWorkingDaysMoreOptions.vue?vue&type=template&id=85a44ef6&scoped=true&ts=true"
import script from "./AddWorkingDaysMoreOptions.vue?vue&type=script&lang=ts"
export * from "./AddWorkingDaysMoreOptions.vue?vue&type=script&lang=ts"

import "./AddWorkingDaysMoreOptions.vue?vue&type=style&index=0&id=85a44ef6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85a44ef6"]])

export default __exports__